import React, { useState, useRef } from 'react'
import styles from './StageQuiz.module.css'
import { useHistory } from 'react-router-dom'
import {useDispatch} from 'react-redux'
import { saveLastScore } from '../../../../store/actions'
import { shuffledArray } from '../../../../util/util'

const StageQuiz = ({
    data,
    onPageChange,
}) => {

    const history = useHistory();

    const shuffledPositions = useRef(shuffledArray([...Array(data.questions.length).keys()]));
    const score = useRef(0);
    const wrongAnswers = useRef(0);

    const [currQuestion, setCurrQuestion] = useState(data.questions[shuffledPositions.current[0]].question)
    const [currAnswers, setCurrAnswers] = useState(shuffledArray(data.questions[shuffledPositions.current[0]].answers))
    const [currQuestionIndex, setCurrQuestionIndex] = useState(0)
    const [badAnswer, setBadAnswer] = useState(-1)
    const [goodAnswer, setGoodAnswer] = useState(-1)
    const [transition, setTransition] = useState(false)
    const [fadeOut, setFadeOut] = useState(false);

    const dispatch = useDispatch()

    // data.questions
    // data[0].question -> question
    // data[0].answers -> array of answers

    const onAnswerClick = (answer, index) => {
        if (data.questions[shuffledPositions.current[currQuestionIndex]].answers[0] === answer) {
            onPageChange(currQuestionIndex + 1)
            if (wrongAnswers.current === 0) {
                score.current += (10 / data.questions.length)
            }
            else if (wrongAnswers.current === 1) {
                score.current += (10 / data.questions.length) / 2
            }
            wrongAnswers.current = 0;
            
            // Good Answer
            setBadAnswer(-1)
            setGoodAnswer(index)
            setTransition(true);
            setTimeout(() => {
                setFadeOut(true);
            }, 500);
            setTimeout(() => {
                setFadeOut(false)
                setGoodAnswer(false)
                setBadAnswer(false)
                setTransition(false)
                const newQuestionIndex = currQuestionIndex + 1

                if (newQuestionIndex >= data.questions.length) {
                    dispatch(saveLastScore(score.current))
                    history.goBack();
                }
                else {
                    setCurrQuestionIndex(newQuestionIndex)
                    setCurrQuestion(data.questions[shuffledPositions.current[newQuestionIndex]].question)
                    setCurrAnswers(shuffledArray(data.questions[shuffledPositions.current[newQuestionIndex]].answers))
                }
            }, 1000)
        }
        else {
            wrongAnswers.current += 1;
            // Bad Answer
            setBadAnswer(index)
            setGoodAnswer(-1)
            setTimeout(() => {
                setBadAnswer(-1)
            }, 1000);
        }
    }

    return (
        <div
            style={{ opacity: fadeOut ? 0 : 1 }}
            className={styles.container}>
            <p className={styles.question}>{currQuestion}</p>
            {
                currAnswers.map((answer, index) => {
                    return (
                        <p
                            onClick={() => transition ? null : onAnswerClick(answer, index)}
                            className={styles.answer}
                            style={
                                badAnswer === index ? { backgroundColor: '#FF6464', color: 'white' } :
                                    goodAnswer === index ? { backgroundColor: '#26C281', color: 'white' } : {}}>{answer}</p>
                    )
                })
            }

        </div>
    )
}



export default StageQuiz
